import { Button } from "primereact/button";
import { Divider } from "primereact/divider";
import { Dropdown } from "primereact/dropdown";
import { useState } from "react";
import { ProgressBar } from "primereact/progressbar";
import { Chart } from "primereact/chart";
import ReactPlayer from "react-player";
import SessionsCarousel from "../../../../../components/sharedComponents/SessionsCarousel";
import PresentationBuilder from "../../../../../components/PresentationBulder/PresentationBuilder";

const slideVideos = [
  { id: 1, name: "Wendoline S", title: "Cooking In Your Home" },
  { id: 2, name: "Alex Q", title: "Cooking In Your Home" },
  { id: 3, name: "Ira D", title: "Cooking In Your Home" },
  { id: 4, name: "Jesseca A", title: "Cooking In Your Home" },
  { id: 5, name: "Jeff B", title: "Cooking In Your Home" },
  { id: 6, name: "Kimberlee C", title: "Cooking In Your Home" },
  { id: 7, name: "Bobby S", title: "Cooking In Your Home" },
  { id: 8, name: "Bobby S", title: "Cooking In Your Home" },
  { id: 9, name: "Bobby S", title: "Cooking In Your Home" },
  { id: 10, name: "Bobby S", title: "Cooking In Your Home" },
];

const TaskQuestionViewResultsTab = () => {
  const [selectedQuestion, setSelectedQuestion] = useState(null);
  const [selected, setSelected] = useState("All");
  const [selectedSession, setSelectedSession] = useState(0);
  const [presentations, setPresentations] = useState([
    {
      id: 1,
      name: "PRESENTATION 1",
      slides: [
        { id: 1, slideName: "Good Not Down 1", slideVideos: [...slideVideos] },
        { id: 2, slideName: "Like It", slideVideos: [...slideVideos] },
        { id: 3, slideName: "Dislike", slideVideos: [...slideVideos] },
      ],
      isPresentationMinimise: false,
    },
  ]);

  const addSlide = (presentationId) => {
    setPresentations((prev) =>
      prev.map((p) =>
        p.id === presentationId
          ? {
              ...p,
              slides: [
                ...p.slides,
                {
                  id: p.slides.length + 1,
                  slideName: "New Slide",
                  slideVideos: [],
                  isPresentationMinimise: false,
                },
              ],
            }
          : p,
      ),
    );
  };

  const handlePresentationMinimize = (pIndex, isMinimized) => {
    setPresentations((prev) =>
      prev.map((p, index) =>
        index === pIndex ? { ...p, isPresentationMinimise: isMinimized } : p,
      ),
    );
  };

  const addPresentation = () => {
    setPresentations((prev) => [
      ...prev,
      {
        id: prev.length + 1,
        name: `PRESENTATION ${prev.length + 1}`,
        slides: [],
      },
    ]);
  };

  const deletePresentation = (index) => {
    setPresentations((prev) => prev.filter((_, i) => i !== index));
  };

  const deleteSlide = (presentationId, slideId) => {
    setPresentations((prev) =>
      prev.map((p, i) =>
        i === presentationId
          ? { ...p, slides: p.slides.filter((slide, sId) => sId !== slideId) }
          : p,
      ),
    );
  };

  const chartData = {
    labels: ["I work full time", "I work part time"],
    datasets: [
      {
        label: "Responses %",
        backgroundColor: ["#2196F3", "#FF9800"],
        data: [80, 20],
      },
    ],
  };

  const chartOptions = {
    indexAxis: "x",
    plugins: {
      legend: { display: false },
    },
    scales: {
      y: {
        beginAtZero: true,
        max: 100,
        title: { display: true, text: "Response %" },
      },
    },
  };

  const sessions = [
    { id: 1, name: "Wendoline S", title: "Cooking In Your Home" },
    { id: 2, name: "Alex Q", title: "Cooking In Your Home" },
    { id: 3, name: "Ira D", title: "Cooking In Your Home" },
    { id: 4, name: "Jesseca A", title: "Cooking In Your Home" },
    { id: 5, name: "Jeff B", title: "Cooking In Your Home" },
    { id: 6, name: "Kimberlee C", title: "Cooking In Your Home" },
    { id: 7, name: "Bobby S", title: "Cooking In Your Home" },
    { id: 8, name: "Bobby S", title: "Cooking In Your Home" },
    { id: 9, name: "Bobby S", title: "Cooking In Your Home" },
    { id: 10, name: "Bobby S", title: "Cooking In Your Home" },
  ];

  const questionOptions = [
    {
      quesName:
        "How do you spend a typical day? (pick one and tell us a little about it verbally)",
      answerOptions: [
        { label: "All", value: "all" },
        { label: "I work full time", value: "fullTime" },
        { label: "I work part-time", value: "partTime" },
      ],
    },
    {
      quesName:
        "How do you spend a typical day Two? (pick one and tell us a little about it verbally)",
      answerOptions: [
        { label: "All", value: "all" },
        { label: "I work full time", value: "fullTime" },
        { label: "I work part-time", value: "partTime" },
      ],
    },
    {
      quesName:
        "How do you spend a typical day Three? (pick one and tell us a little about it verbally)",
      answerOptions: [
        { label: "All", value: "all" },
        { label: "I work full time", value: "fullTime" },
        { label: "I work part-time", value: "partTime" },
      ],
    },
  ];

  const keywords = [
    { keyword: "DESCRIBES", participants: 2, mentions: 2 },
    { keyword: "FEELINGS", participants: 2, mentions: 2 },
    { keyword: "FAMILY", participants: 2, mentions: 2 },
    { keyword: "LAUNDRY", participants: 2, mentions: 2 },
  ];

  return (
    <div className="py-2 px-4 text-start">
      <div
        className="p-3 my-3"
        style={{
          background: "#ccc",
        }}
      >
        {/* Task/Question Header */}
        <div className="mb-4">
          <div className="d-flex align-items-center justify-content-between">
            <h5 className="text_dark fw-600">Select a Task/Question</h5>
            {/* Navigation Buttons */}
            <div className="d-flex justify-content-between align-items-center">
              <Button
                label="Previous Task/Question"
                className="p-button-text"
              />
              <div>|</div>
              <Button label="Next Task/Question" className="p-button-text" />
            </div>
          </div>
          <Dropdown
            value={selectedQuestion}
            options={questionOptions}
            onChange={(e) => setSelectedQuestion(e.value)}
            placeholder="Select a Question"
            optionLabel="quesName"
            className="w-100"
          />
        </div>

        {/* Answer Options Dropdown */}
        {selectedQuestion ? (
          <div className="mb-4">
            <h5 className="text_dark fw-600">Answer Options:</h5>
            <div className="d-flex gap-2">
              {selectedQuestion?.answerOptions?.map((filter, i) => (
                <Button
                  key={i}
                  label={filter.label}
                  onClick={() => setSelected(filter.value)}
                  style={{
                    background: selected === filter.value ? "#002133" : "#fff",
                    border: 0,
                    borderRadius: "2px",
                    color: selected === filter.value ? "#fff" : "#002133",
                  }}
                />
              ))}
            </div>
            <small className="text-muted mt-2 d-block">
              (click on the answer option to filter bar graphs and clips
              accordingly)
            </small>
          </div>
        ) : (
          ""
        )}
      </div>
      <h5 className="text_dark fw-600">Task/Question Summary</h5>
      <p>
        The past few weeks with the product for the most part it went. Okay.
        I've used quite a bit of the spruce grass and weed killer throughout my
        lawn mostly in the landscaping to get rid of weeds. I'm at least kill
        them before I would pick them. It doesn't feel like it's as effective as
        some of the more powerful products and not natural products, but it does
        cause the weeds to wilt and die eventually just takes a little more time
        is what I've been.
      </p>

      <section className="mt-5 filter-by-theme">
        <h5 className="text_dark fw-600">Filter By Theme:</h5>
        <div className="button-group my-3">
          <Button
            label="Skincare Experimentation"
            className="filter-button-text me-3"
          />
          <Button
            label="Brand And Price Considerations"
            className="filter-button-text me-3"
          />
          <Button
            label="Recommendations And Endorsements"
            className="filter-button-text"
          />
        </div>
        <Divider />
      </section>

      <section className="charts-and-keywords my-3">
        <div className="row">
          {/* Chart Section */}
          <div className="col-md-6" style={{ borderRight: "1px solid #ccc" }}>
            <div className="p-3">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="text_dark fw-600 mb-0">CHART</h5>
                <Button
                  label="Save"
                  icon="pi pi-bookmark-fill"
                  className="p-button-sm rounded save-bookmark-btn"
                />
              </div>
              <Chart type="bar" data={chartData} options={chartOptions} />
            </div>
          </div>

          {/* Keywords Section */}
          <div className="col-md-6">
            <div className="p-3">
              <h5 className="text_dark fw-600 mb-3">KEYWORDS</h5>
              <table className="table table-borderless mb-0 clientsTable">
                <thead>
                  <tr style={{ borderBottom: "1px solid #ccc" }}>
                    <th>
                      <div className="d-flex align-items-center">
                        <div className="me-3">KEYWORDS</div>
                        <div className="sorting-icons ms-1">
                          <span className="pi pi-sort-amount-down"></span>
                        </div>
                      </div>
                    </th>
                    <th>
                      <div className="d-flex align-items-center justify-content-center">
                        <div className="me-3">PARTICIPANTS (N=100)</div>
                        <div className="sorting-icons ms-1">
                          <span className="pi pi-sort-amount-down"></span>
                        </div>
                      </div>
                    </th>
                    <th>
                      <div className="d-flex align-items-center justify-content-center">
                        <div className="me-3">MENTIONS</div>
                        <div className="sorting-icons ms-1">
                          <span className="pi pi-sort-amount-down"></span>
                        </div>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {keywords.map((item, idx) => (
                    <tr key={idx}>
                      <td>
                        <div className="d-flex align-items-center justify-content-between">
                          <div>{item.keyword}</div>
                          <div>
                            <i className="pi pi-play ms-5"></i>
                          </div>
                        </div>
                      </td>
                      <td className="text-center">{item.participants}</td>
                      <td className="text-center">{item.mentions}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <Divider />
      </section>

      <section className="sentiment-and-emotions">
        <div className="mt-3">
          {/* SENTIMENT SECTION */}
          <div className="row mb-4">
            <div className="col-6 col-lg-4">
              <h5 className="text_dark fw-600 mb-4">Sentiment</h5>
              <div className="d-flex align-items-center w-100">
                <div className="d-flex justify-content-between align-items-center w-100">
                  <span>Positive</span>
                  <div className="mx-2" style={{ width: "100%" }}>
                    <ProgressBar
                      color="#002133"
                      style={{ height: "16px" }}
                      value={57.85}
                      showValue={false}
                    />
                  </div>
                  <span>{57.85}</span>
                </div>
                <div className="d-flex justify-content-between align-items-center w-100 ms-4">
                  <span>Negative</span>
                  <div className="mx-2" style={{ width: "100%" }}>
                    <ProgressBar
                      color="#002133"
                      style={{ height: "16px" }}
                      value={58.23}
                      showValue={false}
                    />
                  </div>
                  <span>{58.23}</span>
                </div>
              </div>
            </div>

            {/* EMOTIONS SECTION */}
            <div className="col-6 col-lg-4 ps-4">
              <h5 className="text_dark fw-600 mb-4">Emotions</h5>
              <div className="d-flex justify-content-between align-items-center w-50">
                <span>Joy</span>
                <div className="mx-2" style={{ width: "100%" }}>
                  <ProgressBar
                    color="#002133"
                    style={{ height: "16px" }}
                    value={0.39}
                    showValue={false}
                  />
                </div>
                <span>{0.39}</span>
              </div>
            </div>
          </div>
        </div>

        <Divider />
      </section>

      <section className="clips my-3">
        <div className="d-flex align-items-center justify-content-between">
          <h5 className="text_dark fw-600 mb-4">Clips</h5>
          <div className="text-muted fs-12">
            Right-click or drag & drop video clips, images into the appropriate
            slide
          </div>
        </div>
        <SessionsCarousel
          selectedSession={selectedSession}
          setSelectedSession={setSelectedSession}
          sessionsData={sessions}
        />
      </section>

      <div className="row m-0">
        <div className="col-md-6">
          <div className="position-relative">
            <ReactPlayer
              className="w-100"
              style={{ height: "500px" }}
              src="https://www.youtube.com/watch?v=LXb3EKWsInQ"
              controls
            />

            <div className="d-flex align-items-center justify-content-between my-2">
              <h5 className="text_dark fw-600 mb-0">Participant Id: 9926</h5>
              <div className="group-btns d-flex align-items-center">
                <i className="pi pi-download"></i>
                <Button className="px-1 py-0" label="Download Clip" link />
                <span className="text-muted mx-3">|</span>
                <i className="pi pi-video"></i>
                <Button className="px-1 py-0" label="Watch Full Video" link />
              </div>
            </div>

            <Divider />

            <div className="my-2">
              <h5 className="text_dark fw-600">Answer</h5>
              <p>I work full-time</p>
            </div>

            <Divider />

            <div className="my-2">
              <h5 className="text_dark fw-600">Transcript</h5>
              <p>
                Okay. So the first question is, what type of cleaning tools? Do
                you currently use to wash your dishes in your sink? So I'm
                really embarrassed to admit that sponges are kind of the same to
                me. They get smelly, they get kind of stinky, you have to throw
                them away.
              </p>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <PresentationBuilder
            presentations={presentations}
            setPresentations={setPresentations}
            addPresentation={addPresentation}
            addSlide={addSlide}
            deletePresentation={deletePresentation}
            deleteSlide={deleteSlide}
            handlePresentationMinimize={handlePresentationMinimize}
          />
        </div>
      </div>
    </div>
  );
};

export default TaskQuestionViewResultsTab;
